import { Routes, Route, Navigate } from 'react-router-dom';
import NotFoundPage from '../pages/notFound/NotFoundPage';
import HomePage from '../pages/home/homePage';
import NavBar from '../components/navBar';
import AllProductsPage from '../pages/allProducts/allProductsPage';
import FooterWidget from '../components/footerWidget';
import ProductDetails from '../pages/productDetails/ProductDetails';
import UserProfile from '../pages/profile/userProfile';
import OrderDetails from '../pages/profile/OrderDetails';
import ScrollToTop from '../components/ScrollToTop';
import CheckoutPage from '../pages/checkOut/CheckOutPage';
import QRPaymentPage from '../pages/checkOut/QRPaymentPage';
import ResumePaymentPage from '../pages/checkOut/ResumePaymentPage';
import PaymentReturnPage from '../pages/checkOut/PaymentReturnPage';
import ProtectedRoute from '../configs/protectedRoutes';
import HowWeWorkPage from '../pages/howWeWork/HowWeWorkPage';
import ContactPage from '../pages/contact/ContactPage';
import AboutPage from '../pages/about/AboutPage';
import PrivacyPolicyPage from '../pages/privacy/PrivacyPolicyPage';
import TermsPage from '../pages/terms/TermsPage';
import RefundPolicyPage from '../pages/refund/RefundPolicyPage';
import RequestProjectPage from '../pages/requestProject/RequestProjectPage';
import VideosPage from '../pages/videos/VideosPage';
import ReviewsPage from '../pages/reviews/ReviewsPage';
import GithubProjectsPage from '../pages/githubProjects/GithubProjectsPage';
import CodeDetailPage from '../pages/githubProjects/CodeDetailPage';
import VerifyEmailPage from '../pages/verifyEmail/VerifyEmailPage';

const UserRoutes = () => (
  <div className="app-layout layout-surface">
    <ScrollToTop />
    <NavBar />
    <main>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<AllProductsPage />} />
        <Route
          path="/products/:productId/:productTitle"
          element={<ProductDetails />}
        />
        <Route path="/products/:productId" element={<ProductDetails />} />
        <Route path="/how-we-work" element={<HowWeWorkPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/help" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/refund" element={<RefundPolicyPage />} />
        <Route path="/request-project" element={<RequestProjectPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/code" element={<GithubProjectsPage />} />
        <Route path="/code/:key" element={<CodeDetailPage />} />
        <Route path="/github-projects" element={<Navigate to="/code" replace />} />
        <Route path="/payment-status" element={<PaymentReturnPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />

        {/* Signed-in routes */}
        <Route element={<ProtectedRoute allowedRoles={['user', 'admin']} />}>
          <Route path="/checkout/:productId" element={<CheckoutPage />} />
          <Route
            path="/checkout/qr-payment/:productId"
            element={<QRPaymentPage />}
          />
          <Route path="/checkout/pay/:orderId" element={<ResumePaymentPage />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route
            path="/profile/order-details/:orderId"
            element={<OrderDetails />}
          />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </main>
    <FooterWidget />
  </div>
);

export default UserRoutes;
